/** 문자열 -> 배열 처리 */
const SPLITTER = /[,，、|·]+/
export function parseStringElements(input) {
  const toTokens = (v) => String(v)
    .split(SPLITTER)
    .map(s => s.trim())
    .filter(Boolean)

  if (Array.isArray(input)) {
    return input.flatMap(toTokens)
  }
  if (typeof input === 'string') {
    return toTokens(input)
  }
  return []
}

/** 문장 분리 -> 배열 */
// 모든 종류 커버 ver
export function splitYongHuiDesc(text) {
  if (!text || typeof text !== 'string') return null;
  const s = text.trim();

  // 조사 '은/는'이 진짜 조사일 때만: 뒤에 공백/구두점/닫는부호/문장끝
  const boundary = String.raw`(?=[\s,，、.:;!?")\]\}]|$)`;
  let m = s.match(new RegExp(`^(용신|희신)\\s+(.+?)\\s*(?:은|는)${boundary}\\s*(.+)$`));
  if (m) return [m[1].trim(), m[2].trim(), m[3].trim()];

  m = s.match(new RegExp(`^(용신|희신)[의]\\s*(.+?)\\s*(?:은|는)${boundary}\\s*(.+)$`));
  if (m) return [m[1].trim(), m[2].trim(), m[3].trim()];

  if (s.startsWith('용신') || s.startsWith('희신')) {
    const label = s.startsWith('용신') ? '용신' : '희신';
    const tail = s.replace(/^(용신|희신)(의)?\s*/, '');
    const particleRe = new RegExp(`(?:은|는)${boundary}`);
    const idx = tail.search(particleRe);
    if (idx > 0) {
      const elem = tail.slice(0, idx).trim();
      const rest = tail.slice(idx + 1).trim();
      return [label, elem, rest];
    }
    return [label, '', tail.trim()];
  }

  return null;
}



export const ELEMENT_CLASS_MAP = {
  목: 'five03',
  화: 'five01',
  토: 'five05',
  금: 'five04',
  수: 'five02',
};

/** (오행)한글 추출 */
export function normalizeElementKey(raw) {
  if (raw == null) return null;
  const match = String(raw).match(/[목화토금수]/);
  return match ? match[0] : null;
}

/** 매핑 */
export function getFiveClass(raw) {
  const key = normalizeElementKey(raw);
  return key ? ELEMENT_CLASS_MAP[key] || null : null;
}

/** 문장 분리한 배열에서 클래스 구하기 */
export function getFiveClassForParts(parts) {
  if (!parts || !Array.isArray(parts)) return null;
  return getFiveClass(parts[1]);
}

// 숫자 컬러 매핑
const NUM_CLASS_MAP = new Map([
  [1, 'yh-num-black'],  [6, 'yh-num-black'],
  [2, 'yh-num-red'],    [7, 'yh-num-red'],
  [3, 'yh-num-green'],  [8, 'yh-num-green'],
  [4, 'yh-num-gray'],   [9, 'yh-num-gray'],
  [5, 'yh-num-yellow'], [10,'yh-num-yellow'],
]);

/** 단일 숫자 처리 */
export function getNumClass(n, opts = {}) {
  const { withBase = false } = opts;
  const key = Number(n);
  const variant = NUM_CLASS_MAP.get(key);
  if (!variant) return null;
  return withBase ? `yh-num ${variant}` : variant;
}

/** 배열 내 숫자 처리 */
export function parseNumberElements(input) {
  const toTokens = (v) => String(v)
    .split(SPLITTER)
    .map(s => s.trim())
    .filter(Boolean)
    .map(Number)
    .filter(Number.isFinite)

  if (Array.isArray(input)) {
    return input.flatMap(item => 
      typeof item === 'number' ? [item] : toTokens(item)
    )
  }
  if (typeof input === 'string') {
    return toTokens(input)
  }
  if (typeof input === 'number') {
    return [input]
  }
  return []
}

// 용신 / 희신 색상
/** 컬러 적용 */
const COLOR_MAP = {
  '흰색': '#ffffff',
  '금색': '#f0c84e',
  '은색': '#d9d9d9',
  '검정': '#000000',
  '남색': '#2e3a8c',
  '파랑': '#1557ff',
  '진청': '#031252',
  '초록': '#228B22',
  '청록': '#20B2AA',
  '연두': '#9ACD32',
  '빨강': '#FF3B30',
  '주황': '#FFA500',
  '분홍': '#FF69B4',
  '노랑': '#FFD400',
  '갈색': '#8B5E3C',
  '베이지': '#F9E4B7',
}

/** HEX 변환 */
export const resolveHex = (name) => COLOR_MAP[name] ?? '#ebebeb'
/** 객체 형태로 변환 */
export const normalizeColorList = (names) =>
  (Array.isArray(names) ? names : [])
    .filter(Boolean)
    .map(label => ({ label, hex: resolveHex(label) }))



// 문장 분리 YongHeeData.vue ver.
export function parseYhSentence(sentence, kind) {
  const parts = splitYongHuiDesc(sentence)
  const emptyDesc = sentence || ''
  if (!parts) {
    if (kind === 'color')     return { colors: [], description: emptyDesc }
    if (kind === 'number')    return { numbers: [], description: emptyDesc }
    if (kind === 'direction') return { directions: [], description: emptyDesc }
    return { description: emptyDesc }
  }
  let [, elem, rest] = parts
  if (kind === 'color') {
    elem = elem.replace(/^색상\s*/, '')
    const names  = parseStringElements(elem);
    const colors = names.map(resolveHex);    
    return { colors, description: rest };
  }
  if (kind === 'number') {
    elem = elem.replace(/^숫자\s*/, '')
    const numbers = parseStringElements(elem).map(Number).filter(Number.isFinite)
    return { numbers, description: rest }
  }
  if (kind === 'direction') {
    const directions = parseStringElements(elem)
    return { directions, description: rest }
  }

  return { description: rest }
}
